import styled from 'styled-components';
import { theme } from '../../../../../theme';

export const DivTable = styled.div`
  .fn-table {
    .table {
      thead {
        tr {
          th {
            font-size: 0.923rem;
            padding: 0.9rem 1.3em;
          }
        }
      }
      tbody {
        td {
          font-size: 0.923rem;
          padding: 0.93rem 1.3rem;
        }
        tr {
          &:first-child {
            td {
              padding: 0.93rem 1.3rem;
            }
          }
          &:last-child {
            td {
              padding: 0.93rem 1.3rem;
            }
          }
        }
      }
    }
  }
`;

export const DivApplyChanges = styled.div`
  padding: 1.538rem
  background-color: ${theme.colors.surfaceBase};

  & .form-group .form-check {
    margin-bottom: 1.538rem
  }

  & .form-group .form-check:not(.has-inner-block):last-child {
    margin-bottom: 0.615rem
  }
`;

export const DivTitleApply = styled.div`
  margin-bottom: 1.231rem;
  font-size: 1.078rem;
  font-weight: 600;
  color: ${theme.colors.textPrimary};
`;
